<section
  class="modal fade"
  id="modalLoginForm"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header text-center ">
        <h4 class="modal-title w-100 font-weight-bold">SIGN IN</h4>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="signInForm" (ngSubmit)="loginUser()" onsubmit="$('.modal').modal('hide')" class="was-validated">
        <div class="modal-body container">
          <div class="form-group">
            <input
              type="email"
              id="email"
              name="email"
              class="form-control"
              placeholder="Email"
              required
              formControlName="email"
            />
            <small class="invalid-feedback">Please fill a valid Email.</small>
          </div>
          <div class="form-group">
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="Password"
              required
              minlength="6"
              maxlength="20"
              formControlName="password"
            />
          <small class="invalid-feedback">
            Must be 6-20 characters long.
          </small>
          </div>
        
      <div class="text-center justify-content-center">
        <button type="submit" class="btn buttonStyle" >Login</button>
      </div>
    </div>
      <div class="modal-footer mx-5 pt-3 mb-1">
        <p class="styleLogin grey-text d-flex justify-content-end">
          Not a member? <a routerLink="signup"
          data-dismiss="modal" class="blue-text ml-1"> Sign Up</a>
        </p>
      </div>
    </form>
    </div>
  </div>
</section>
